var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-small relative w-full align-middle content-center"},[_c('div',{staticClass:"absolute top-0 left-0"},[_vm._t("left")],2),_vm._t("default"),_c('div',{staticClass:"absolute top-0 right-0 h-full z-10"},[_vm._t("right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }